<template>
  <FileTable :isAdmin="isAdmin" ref="fileTable" />
</template>

<script>
import FileTable from "./PublicHoliday.vue";
import store from "@/store/store";
export default {
  components: {
    FileTable,
  },
  computed: {
    isAdmin() {
      const user = store.state.auth.user;
      return user && user.role === "admin";
    }
  },
  methods: {
    refreshFiles() {
      this.$refs.fileTable && this.$refs.fileTable.$forceUpdate();
    }
  }
};
</script>

<style scoped>
/* Optional: spacing and styling for button */
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/PublicHoliday/index.vue